module.exports = __webpack_public_path__ + "static/media/29BDOS24.d1a968a5.jpg";